<script setup lang="ts">
defineProps<{
  routeLabel: string
}>()
</script>

<template>
  <section class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <h1 class="text-2xl font-semibold text-slate-900">{{ routeLabel }}</h1>
  </section>
</template>

